import { postToTopIframe } from "helpers/window-messages";

export const postGotoProduct = (brandId: string, productId: string) => {
    // in theory, brandId could be undefined when is not fetching yet
    if (brandId) {
        postToTopIframe({ action: "goto", href: getProductLink(brandId, productId) });
    }
};

export const getProductLink = (brandId, productId) => {
    return brandId && productId ? `/brand/${brandId}/item/${productId}` : "#";
};
